//文件编制
import React from 'react'
import Manager from 'Tyan/public/components/Manager'
import DocumentDraftingDiv from './DocumentDraftingDiv'

Ext.require('Ext.Toast')

const config = {
    tabs: {
        起草中: {
            buttons: [
                { text: '添加...', handler: ({ showDetail, refreshPage }) => Tyan.pubForm.showDialog('文件起草', props => <DocumentDraftingDiv {...props} id={0} onSave={refreshPage} />) },
            ],
            columns: [
                { _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
                { _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, },
                { _text: '版别', field: 'Version', minWidth: 150,  },
                { _text: '所属目录', field: 'QualityFileDirectory', minWidth: 150, },
                { _text: '起草人', field: 'DraftOutPerson', minWidth: 150, },
                { _date: '起草日期', field: 'DraftOutDate', minWidth: 150, },
                { _text: '文件状态', field: 'StatusName', minWidth: 150, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
                Tyan.pubForm.showDialog('文件起草', props => <DocumentDraftingDiv {...props} id={data.id} onSave={refreshPage} onFlowFinished={refreshPage} />)
            },
        },
        被退回: {
            buttons: [
            ],
            columns: [
                { _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
                { _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, },
                { _text: '版别', field: 'Version', minWidth: 150, },
                { _text: '所属目录', field: 'QualityFileDirectory', minWidth: 150, },
                { _text: '起草人', field: 'DraftOutPerson', minWidth: 150,  },
                { _date: '起草日期', field: 'DraftOutDate', minWidth: 150,  },
                { _text: '文件状态', field: 'StatusName', minWidth: 150, filter: true, },
                { _text: '退回原因', field: 'ReturnReason', minWidth: 150,  },

            ],
            onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
                Tyan.pubForm.showDialog('文件起草', props => <DocumentDraftingDiv {...props} id={data.id} onSave={refreshPage} onFlowFinished={refreshPage}/>)
            },
        },
        已完成: {
            buttons: [
            ],
            columns: [
                { _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
                { _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, },
                { _text: '版别', field: 'Version', minWidth: 150, },
                { _text: '所属目录', field: 'QualityFileDirectory', minWidth: 150, },
                { _text: '起草人', field: 'DraftOutPerson', minWidth: 150, },
                { _date: '起草日期', field: 'DraftOutDate', minWidth: 150,  },
                { _text: '文件状态', field: 'StatusName', minWidth: 150, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
                Tyan.pubForm.showDialog('文件起草', props => <DocumentDraftingDiv {...props} id={data.id} onFlowFinished={refreshPage} onSave={refreshPage} />)
            },
        }
    }
}

export default props => <Manager {...props} config={config} />